import { useCallback, useEffect, useMemo, useState } from 'react';
import { localStorageService } from '@app/common/storage';
import { useServerConfigContext } from '@common/server-config-context/server-config-context';
import { renderVersionAlert } from './render-version-alert';
const VERSION_UPDATE_LOCAL_STORAGE_KEY = 'versionUpdate';
export const VERSION_NOTIFICATIONS_LOCAL_STORAGE_KEY = 'versionNotifications';
export function useServerVersionNotifications() {
    const context = useServerConfigContext();
    const [notifications, setNotifications] = useState(localStorageService.get(VERSION_NOTIFICATIONS_LOCAL_STORAGE_KEY));
    const showNotification = useMemo(() => {
        if (context.isInitialized()) {
            return compareBuildVersions(context.getAvailableUpdates());
        }
        return false;
    }, [context]);
    const handleUserAction = useCallback((section) => {
        if (!notifications || !notifications[section]) {
            return;
        }
        const newNotificationsValue = {
            ...notifications,
            [section]: false
        };
        localStorageService.set(VERSION_NOTIFICATIONS_LOCAL_STORAGE_KEY, newNotificationsValue);
        setNotifications(newNotificationsValue);
    }, [notifications]);
    const resetNotifications = () => {
        const initialNotification = {
            upgradeVersion: true,
            whatsNew: true
        };
        localStorageService.set(VERSION_NOTIFICATIONS_LOCAL_STORAGE_KEY, initialNotification);
        setNotifications(initialNotification);
    };
    useEffect(() => {
        if (showNotification) {
            const availableUpdate = context.getAvailableUpdates();
            if (availableUpdate) {
                localStorageService.set(VERSION_UPDATE_LOCAL_STORAGE_KEY, availableUpdate);
                resetNotifications();
                renderVersionAlert(availableUpdate.releaseNotesUrl);
            }
        }
    }, [context, showNotification]);
    return useMemo(() => ({
        notifications,
        setNotifications: handleUserAction
    }), [handleUserAction, notifications]);
}
function compareBuildVersions(data) {
    if (!data) {
        localStorageService.set(VERSION_UPDATE_LOCAL_STORAGE_KEY, null);
        return false;
    }
    const savedVersion = localStorageService.get(VERSION_UPDATE_LOCAL_STORAGE_KEY);
    if (!savedVersion) {
        return true;
    }
    return savedVersion.buildNumber !== data.buildNumber;
}
